import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdministrationRoutingModule } from './administration-routing.module';
import { ActivityComponent } from './activity/activity.component';
import { AdminModule } from '../admin/admin.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { AlertModule} from 'ngx-bootstrap'; 
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CircularComponent } from './circular/circular.component';
import { NoticeBoardComponent } from './notice-board/notice-board.component';
import { HolidayListComponent } from './holiday-list/holiday-list.component';
import { PhotoGalaryComponent } from './photo-galary/photo-galary.component';
import { VideoGalaryComponent } from './video-galary/video-galary.component';
import { TcComponent } from './tc/tc.component';
import { AdsSliderComponent } from './ads-slider/ads-slider.component';
import { FacilityComponent } from './facility/facility.component';
import { SchoolInformationComponent } from './school-information/school-information.component';
import { CareerComponent } from './career/career.component';
import { SchoolNewsComponent } from './school-news/school-news.component';
import { NgxEditorModule } from 'ngx-editor';
import { AcademicComponent } from './academic/academic.component';

@NgModule({
  declarations: [ActivityComponent, CircularComponent, NoticeBoardComponent, HolidayListComponent, 
    PhotoGalaryComponent, VideoGalaryComponent, TcComponent, AdsSliderComponent, FacilityComponent, 
    SchoolInformationComponent, CareerComponent, SchoolNewsComponent,AcademicComponent],
  imports: [
    CommonModule,
    AdministrationRoutingModule,
    AdminModule,
    NgbModule,
    FormsModule,
    AlertModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxEditorModule,
   
  ]
})
export class AdministrationModule { }
